import React from 'react';
import DropdownFilterCell from './DropdownFilterCell';

const NestedEntitiesFilterCell = ({ nestedEntities, onChange }) => (props) => {
  const handleChange = (e) => {
    onChange?.(e);
    props?.onChange?.(e);
  };

  return <DropdownFilterCell {...props} data={nestedEntities} onChange={handleChange} />;
};

export default NestedEntitiesFilterCell;
